"use strict";

// "use strict";

jQuery(document).ready(function ($) {
  $('.tabbed-content-block__tab-btn').on('click', function () {
    var $btn = $(this);
    var $wrapper = $btn.closest('.tabbed-content-block__tabs-wrapper');
    var tabIndex = $btn.data('tab-index');

    // Remove active class from all buttons and panes
    $wrapper.find('.tabbed-content-block__tab-btn').removeClass('active');
    $wrapper.find('.tabbed-content-block__tab-pane').removeClass('active');

    // Add active class to clicked button and corresponding pane
    $btn.addClass('active');
    $wrapper.find('.tabbed-content-block__tab-pane[data-tab-index="' + tabIndex + '"]').addClass('active');
  });
});